<template>
  <div>
    <NavBar />
    <LoginForm />
  </div>
</template>
  
<script>
import NavBar from "../components/NavBar.vue";
import LoginForm from "../components/LoginForm.vue";

export default {
  components: {
    NavBar,
    LoginForm,
  },
};
</script>